import { connectFela } from '../../dependencies';
import CompanyDetail from './CompanyDetail';
import * as styles from './CompanyDetail.styles';

export default connectFela(styles)(CompanyDetail);
